import React from 'react';
import { FaEdit } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { Card, CardImg, CardText, CardBody, CardFooter, CardHeader, Button, Label, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import url from "./variables/url.js";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

const colors = ['#FFFFFF', '#354750', '#F48700', '#A72186', '#1DA656', '#EA3B13','#1F58AB']


class ActividadCard extends React.Component {
    constructor(props) {
        super(props);
        const {
            idaexregistroactividad = 0, categoria = 0, idaextipoactividad = 0,
            nombre = '', descripcionact = '', anio = '', horas = 0, idestudiante = 0,
            /*gestion = { estado: 'I' }*/
        } = props.actividad || {};
        this.state = {
            tipos: [],
            insignias: []
        };
        this.handleEdit = this.handleEdit.bind(this);
    }

    componentDidMount() {
        this.populateInfoData();        
    }

    render() {
        return (
            <div id={"ActividadCard-" + this.props.actividad.idaexregistroactividad} className="actividad-card py-1" style={{ height: "100%" }}>
                <Card style={{ borderColor: '#333', height: "100%" }}>
                    <CardHeader style={{ color: this.props.actividad.registroActividadGestion.estado == 'A' ? colors[0] : '#000000', backgroundColor: this.props.actividad.registroActividadGestion.estado == 'A' ? colors[this.props.actividad.categoria]: colors[0] , borderColor: '#333' }}>{this.props.actividad.nombre}</CardHeader>
                    <CardBody>                     
 
                        <CardText>Tipo:</CardText>
                        <CardText >
                            <p style={{ fontSize: "1vw" }}> {this.state.tipos.map(tipo => {
                                return tipo.idaextipoactividad == this.props.actividad.idaextipoactividad ? <Label>{tipo.nombre}</Label> : <></>
                            })}</p>
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">                      
                        {this.props.actividad.registroActividadGestion.estado === 'I' ? <Badge color="primary">Ingresado</Badge> : this.props.actividad.registroActividadGestion.estado === 'A' ? <Badge color="success">Aprobado</Badge> : this.props.actividad.registroActividadGestion.estado === 'D' ? <Badge color="warning">Devuelto</Badge> : <Badge color="danger">Rechazado</Badge>}
                       
                        <FaEdit hidden={this.props.actividad.registroActividadGestion.estado === 'D' ? false : true} className='icon-pointer float-right' onClick={(id) => this.props.edit(this.props.actividad.idaexregistroactividad)} />                                               
                    </CardFooter>
                </Card>
            </div>
        )
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    insignias: data.objDatos
                });
            });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos                    
                });
            });

    }

    handleEdit(id) {
        /*console.log("Editar " + id);*/
        this.props.history.push("/Edit-Act/" + id);
    }
}

ActividadCard.propTypes = {
    actividad: PropTypes.shape({        
        idaexregistroactividad: PropTypes.number.isRequired,
        categoria: PropTypes.number.isRequired,
        idaextipoactividad: PropTypes.number.isRequired,       
        nombre: PropTypes.string.isRequired,
        descripcionact: PropTypes.string.isRequired,
        anio: PropTypes.string.isRequired,
        horas: PropTypes.number.isRequired,
        idestudiante: PropTypes.number.isRequired,
        registroActividadGestion: PropTypes.shape({
            estado: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    edit: PropTypes.func
};

export default ActividadCard;
